/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * shortsworks
 * 

#ShortsWorksAPIDocs

##버전

헤더에그룹화된태그를추가하는방식으로버저닝을지원합니다.

예시)
```

GET{{host}}/account/signin
headers=[
...
{"x-api-version":"2024-09-01"},
...
]

```

버전리스트
***2024-09-01**(version을적지않으면기본적용되는버전)
***2024-10-16**


 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  ExternalProductResponseDto,
  GetProductListForAuthCheckParams,
  GetProductListParams,
  HTTPValidationError
} from '.././model'
import { client } from '../../lib/client';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 연동된플랫폼의상품을가져오는API
 * @summary GetProductList
 */
export const getProductList = (
    params: GetProductListParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<ExternalProductResponseDto>(
      {url: `/external/product/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetProductListQueryKey = (params: GetProductListParams,) => {
    return [`/external/product/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProductListQueryOptions = <TData = Awaited<ReturnType<typeof getProductList>>, TError = HTTPValidationError>(params: GetProductListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductList>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductList>>> = ({ signal }) => getProductList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductListQueryResult = NonNullable<Awaited<ReturnType<typeof getProductList>>>
export type GetProductListQueryError = HTTPValidationError


export function useGetProductList<TData = Awaited<ReturnType<typeof getProductList>>, TError = HTTPValidationError>(
 params: GetProductListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetProductList<TData = Awaited<ReturnType<typeof getProductList>>, TError = HTTPValidationError>(
 params: GetProductListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductList>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetProductList<TData = Awaited<ReturnType<typeof getProductList>>, TError = HTTPValidationError>(
 params: GetProductListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetProductList
 */

export function useGetProductList<TData = Awaited<ReturnType<typeof getProductList>>, TError = HTTPValidationError>(
 params: GetProductListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetProductListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProductList>>, TError = HTTPValidationError>(params: GetProductListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductList>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductList>>> = ({ signal }) => getProductList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProductList>>>
export type GetProductListSuspenseQueryError = HTTPValidationError


export function useGetProductListSuspense<TData = Awaited<ReturnType<typeof getProductList>>, TError = HTTPValidationError>(
 params: GetProductListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetProductListSuspense<TData = Awaited<ReturnType<typeof getProductList>>, TError = HTTPValidationError>(
 params: GetProductListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetProductListSuspense<TData = Awaited<ReturnType<typeof getProductList>>, TError = HTTPValidationError>(
 params: GetProductListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetProductList
 */

export function useGetProductListSuspense<TData = Awaited<ReturnType<typeof getProductList>>, TError = HTTPValidationError>(
 params: GetProductListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductList>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 연동된플랫폼의상품을가져오는방법을통해플랫폼과의연동을확인하는API
 * @summary GetProductListForAuthCheck
 */
export const getProductListForAuthCheck = (
    params: GetProductListForAuthCheckParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<ExternalProductResponseDto>(
      {url: `/external/product/auth-check`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetProductListForAuthCheckQueryKey = (params: GetProductListForAuthCheckParams,) => {
    return [`/external/product/auth-check`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProductListForAuthCheckQueryOptions = <TData = Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError = HTTPValidationError>(params: GetProductListForAuthCheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductListForAuthCheckQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductListForAuthCheck>>> = ({ signal }) => getProductListForAuthCheck(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductListForAuthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof getProductListForAuthCheck>>>
export type GetProductListForAuthCheckQueryError = HTTPValidationError


export function useGetProductListForAuthCheck<TData = Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError = HTTPValidationError>(
 params: GetProductListForAuthCheckParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductListForAuthCheck>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetProductListForAuthCheck<TData = Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError = HTTPValidationError>(
 params: GetProductListForAuthCheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductListForAuthCheck>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetProductListForAuthCheck<TData = Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError = HTTPValidationError>(
 params: GetProductListForAuthCheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetProductListForAuthCheck
 */

export function useGetProductListForAuthCheck<TData = Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError = HTTPValidationError>(
 params: GetProductListForAuthCheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductListForAuthCheckQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetProductListForAuthCheckSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError = HTTPValidationError>(params: GetProductListForAuthCheckParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductListForAuthCheckQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductListForAuthCheck>>> = ({ signal }) => getProductListForAuthCheck(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductListForAuthCheckSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProductListForAuthCheck>>>
export type GetProductListForAuthCheckSuspenseQueryError = HTTPValidationError


export function useGetProductListForAuthCheckSuspense<TData = Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError = HTTPValidationError>(
 params: GetProductListForAuthCheckParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetProductListForAuthCheckSuspense<TData = Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError = HTTPValidationError>(
 params: GetProductListForAuthCheckParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetProductListForAuthCheckSuspense<TData = Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError = HTTPValidationError>(
 params: GetProductListForAuthCheckParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetProductListForAuthCheck
 */

export function useGetProductListForAuthCheckSuspense<TData = Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError = HTTPValidationError>(
 params: GetProductListForAuthCheckParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductListForAuthCheck>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductListForAuthCheckSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



